import {combineReducers} from 'redux'

// import routes from './routes'
import {cadAcesso, coAcesso} from './acesso'
import {coDispositivo} from './dispositivo'
import auth from './auth'

export default combineReducers({
  cadAcesso,
  coAcesso,
  coDispositivo,
  auth
})


// WEBPACK FOOTER //
// ./src/reducers/index.js